/**
 * This file was generated
 * Do not edit directly
 * See 'fusion-design-system/build-style-dictionary.js' for more info
 */

export const fontFamilyUtilityVariants = () => ({
    "sans": "sui-u-font-family-sans",
    "mono": "sui-u-font-family-mono",
});

export const fontWeightUtilityVariants = () => ({
    "book": "sui-u-font-weight-book",
    "regular": "sui-u-font-weight-regular",
    "medium": "sui-u-font-weight-medium",
    "bold": "sui-u-font-weight-bold",
    "code-1": "sui-u-font-weight-code-1",
    "code-2": "sui-u-font-weight-code-2",
    "label-1": "sui-u-font-weight-label-1",
    "label-2": "sui-u-font-weight-label-2",
    "tag-1": "sui-u-font-weight-tag-1",
    "annotation-1": "sui-u-font-weight-annotation-1",
    "annotation-2": "sui-u-font-weight-annotation-2",
    "body-1": "sui-u-font-weight-body-1",
    "body-2": "sui-u-font-weight-body-2",
    "body-3": "sui-u-font-weight-body-3",
    "body-4": "sui-u-font-weight-body-4",
    "heading-1": "sui-u-font-weight-heading-1",
    "heading-2": "sui-u-font-weight-heading-2",
    "heading-3": "sui-u-font-weight-heading-3",
    "heading-4": "sui-u-font-weight-heading-4",
    "heading-5": "sui-u-font-weight-heading-5",
    "heading-6": "sui-u-font-weight-heading-6",
    "heading-7": "sui-u-font-weight-heading-7",
    "heading-8": "sui-u-font-weight-heading-8",
});

export const fontSizeUtilityVariants = () => ({
    "code-1": "sui-u-font-size-code-1",
    "code-1-mobile": "sui-u-font-size-code-1-mobile",
    "code-2": "sui-u-font-size-code-2",
    "code-2-mobile": "sui-u-font-size-code-2-mobile",
    "label-1": "sui-u-font-size-label-1",
    "label-1-mobile": "sui-u-font-size-label-1-mobile",
    "label-2": "sui-u-font-size-label-2",
    "label-2-mobile": "sui-u-font-size-label-2-mobile",
    "tag-1": "sui-u-font-size-tag-1",
    "tag-1-mobile": "sui-u-font-size-tag-1-mobile",
    "annotation-1": "sui-u-font-size-annotation-1",
    "annotation-2": "sui-u-font-size-annotation-2",
    "body-1": "sui-u-font-size-body-1",
    "body-1-mobile": "sui-u-font-size-body-1-mobile",
    "body-2": "sui-u-font-size-body-2",
    "body-2-mobile": "sui-u-font-size-body-2-mobile",
    "body-3": "sui-u-font-size-body-3",
    "body-3-mobile": "sui-u-font-size-body-3-mobile",
    "body-4": "sui-u-font-size-body-4",
    "body-4-mobile": "sui-u-font-size-body-4-mobile",
    "heading-1": "sui-u-font-size-heading-1",
    "heading-1-mobile": "sui-u-font-size-heading-1-mobile",
    "heading-2": "sui-u-font-size-heading-2",
    "heading-2-mobile": "sui-u-font-size-heading-2-mobile",
    "heading-3": "sui-u-font-size-heading-3",
    "heading-3-mobile": "sui-u-font-size-heading-3-mobile",
    "heading-4": "sui-u-font-size-heading-4",
    "heading-4-mobile": "sui-u-font-size-heading-4-mobile",
    "heading-5": "sui-u-font-size-heading-5",
    "heading-5-mobile": "sui-u-font-size-heading-5-mobile",
    "heading-6": "sui-u-font-size-heading-6",
    "heading-6-mobile": "sui-u-font-size-heading-6-mobile",
    "heading-7": "sui-u-font-size-heading-7",
    "heading-7-mobile": "sui-u-font-size-heading-7-mobile",
    "heading-8": "sui-u-font-size-heading-8",
    "heading-8-mobile": "sui-u-font-size-heading-8-mobile",
});

export const lineHeightUtilityVariants = () => ({
    "1": "sui-u-line-height-1",
    "2": "sui-u-line-height-2",
    "3": "sui-u-line-height-3",
    "4": "sui-u-line-height-4",
    "fit": "sui-u-line-height-fit",
    "code-1": "sui-u-line-height-code-1",
    "code-2": "sui-u-line-height-code-2",
    "label-1": "sui-u-line-height-label-1",
    "label-2": "sui-u-line-height-label-2",
    "tag-1": "sui-u-line-height-tag-1",
    "annotation-1": "sui-u-line-height-annotation-1",
    "annotation-2": "sui-u-line-height-annotation-2",
    "body-1": "sui-u-line-height-body-1",
    "body-2": "sui-u-line-height-body-2",
    "body-3": "sui-u-line-height-body-3",
    "body-4": "sui-u-line-height-body-4",
    "heading-1": "sui-u-line-height-heading-1",
    "heading-2": "sui-u-line-height-heading-2",
    "heading-3": "sui-u-line-height-heading-3",
    "heading-4": "sui-u-line-height-heading-4",
    "heading-5": "sui-u-line-height-heading-5",
    "heading-6": "sui-u-line-height-heading-6",
    "heading-7": "sui-u-line-height-heading-7",
    "heading-8": "sui-u-line-height-heading-8",
});

export const letterSpacingUtilityVariants = () => ({
    "1": "sui-u-letter-spacing-1",
    "2": "sui-u-letter-spacing-2",
    "negative-1": "sui-u-letter-spacing-negative-1",
    "code-1": "sui-u-letter-spacing-code-1",
    "code-2": "sui-u-letter-spacing-code-2",
    "label-1": "sui-u-letter-spacing-label-1",
    "label-2": "sui-u-letter-spacing-label-2",
    "tag-1": "sui-u-letter-spacing-tag-1",
    "annotation-1": "sui-u-letter-spacing-annotation-1",
    "annotation-2": "sui-u-letter-spacing-annotation-2",
    "body-1": "sui-u-letter-spacing-body-1",
    "body-2": "sui-u-letter-spacing-body-2",
    "body-3": "sui-u-letter-spacing-body-3",
    "body-4": "sui-u-letter-spacing-body-4",
    "heading-1": "sui-u-letter-spacing-heading-1",
    "heading-2": "sui-u-letter-spacing-heading-2",
    "heading-3": "sui-u-letter-spacing-heading-3",
    "heading-4": "sui-u-letter-spacing-heading-4",
    "heading-5": "sui-u-letter-spacing-heading-5",
    "heading-6": "sui-u-letter-spacing-heading-6",
    "heading-7": "sui-u-letter-spacing-heading-7",
    "heading-8": "sui-u-letter-spacing-heading-8",
});
